import RegisterAdminPage from "./RegisterAdminPage";

export default RegisterAdminPage;